import { render, staticRenderFns } from "./exhibition-order-all.vue?vue&type=template&id=af16ba82&scoped=true&"
import script from "./exhibition-order-all.vue?vue&type=script&lang=js&"
export * from "./exhibition-order-all.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af16ba82",
  null
  
)

export default component.exports